import * as contentful from "contentful";

class BlogService {
  private space: string = "aioui4ylmtq9";
  private apiKey: string = "rXiLTf_6T2eDMdcsDOdm4dTBbQhz4Pgm1AcgcMB8WdE";

  private contentfulClient: contentful.ContentfulClientApi;

  constructor() {
    this.contentfulClient = contentful.createClient({
      space: this.space,
      accessToken: this.apiKey,
    });
  }

  public getPosts(language: string) {
    const locale = language === "es" ? "es-MX" : "en-US";
    return this.contentfulClient.getEntries({ locale });
  }

  public getPost(id: string, language: string) {
    const locale = language === "es" ? "es-MX" : "en-US";
    return this.contentfulClient.getEntry(id, { locale });
  }

  public getPostBySlug(slug: string, contentType: string, language: string) {
    const locale = language === "es" ? "es-MX" : "en-US";
    return this.contentfulClient.getEntries({
      content_type: contentType,
      "fields.slug[in]": slug,
      locale,
    });
  }

  public searchPost(query: string, contentType: string, language: string) {
    const locale = language === "es" ? "es-MX" : "en-US";
    return this.contentfulClient.getEntries({
      content_type: contentType,
      query,
      locale,
    });
  }
}

export default BlogService;
